var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpamdefence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 161,
    viewBox: "0 0 375 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 374.642,
    height: 160.561,
    fill: "url(#pattern0_6_2014)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2014)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M242.455 57.1983L211.297 52.3917L206.496 51.6483L198.906 42.4569L196.96 36.5603L195.239 38.0219L199.373 50.5534L190.082 49.1219L189.625 49.132V49.1219H164.658L163.248 53.5218L153.139 47.6051L148.273 44.7573L134.277 36.5653L121.981 57.6202L140.844 68.66L141.797 69.2175L145.9 71.6183L157.559 78.4441L164.236 93.728H135.436V95.1896H192.625L207.208 94.0947V125.501C207.369 125.486 208.834 125.305 211.573 124.532C212.942 124.145 215.762 123.291 215.762 123.291V93.4568L218.691 93.2358L219.981 93.1404L242.345 91.4628L248.515 76.8168L242.45 57.2084L242.455 57.1983Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.645 44.5664H159.996L158.807 48.2832L166.312 52.678L162.018 60.0311L169.974 59.1622L174.645 44.5664Z",
    fill: "url(#paint0_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.97 84.6821L158.873 65.4253L154.022 73.7327L153.942 73.6875L160.093 87.766H174.741L172.825 83.3863L160.97 84.6821Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.692 82.3063L172.824 83.3862L174.74 87.7659H185.932L187.894 81.7388L182.692 82.3063Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.044 58.0622L186.365 57.3691L187.669 57.2285L183.395 44.5865L182.953 44.5965L182.943 44.5664H178.875H174.646L169.975 59.1622L180.044 58.0622Z",
    fill: "url(#paint1_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.825 83.3864L182.693 82.3065L182.688 82.2914L172.82 83.3713L160.971 84.6672L169.539 75.8574L175.439 69.7901L167.894 65.6665L160.951 61.8694L158.874 65.4254L160.971 84.6822L172.825 83.3864Z",
    fill: "#FFC4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.644 73.1803L175.438 69.79L169.539 75.8574L160.97 84.6671L172.82 83.3713L182.687 82.2914L181.689 73.1401L181.644 73.1803Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.438 69.7901L181.643 73.1804L181.688 73.1402L180.74 64.4209L180.043 58.0623L169.975 59.1622L162.018 60.0311L160.95 61.8694L167.893 65.6665L175.438 69.7901Z",
    fill: "#FD826A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.043 58.062L186.364 57.3689L180.043 58.062Z",
    fill: "#002623"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.043 58.062L186.364 57.3689L180.043 58.062Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27 71.352L191.842 69.5841L191.837 69.569L190.458 65.4856L186.976 68.5243L191.27 71.352Z",
    fill: "#FFC4BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.27 71.352L191.842 69.5841L191.837 69.569L190.458 65.4856L186.976 68.5243L191.27 71.352Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.691 82.3065L187.894 81.7389L187.899 81.7239L182.686 82.2914L182.691 82.3065Z",
    fill: "#FFC4BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.691 82.3065L187.894 81.7389L187.899 81.7239L182.686 82.2914L182.691 82.3065Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.689 73.1402L182.687 82.2915L187.9 81.7239L191.271 71.3522L186.977 68.5244L181.689 73.1402Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.689 73.1402L182.687 82.2915L187.9 81.7239L191.271 71.3522L186.977 68.5244L181.689 73.1402Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.043 58.062L180.74 64.4207L181.688 73.14L186.976 68.5242L190.457 65.4855L187.668 57.2283L186.364 57.3689L180.043 58.062Z",
    fill: "#FD826A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.043 58.062L180.74 64.4207L181.688 73.14L186.976 68.5242L190.457 65.4855L187.668 57.2283L186.364 57.3689L180.043 58.062Z",
    fill: "#FF9E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.104 57.0726L191.607 64.4861L193.328 69.579L203.306 69.8352L242.837 70.8497L236.772 51.2413L205.613 46.4347L200.812 45.6913L202.714 47.9967L209.928 56.7311L204.334 60.5232C204.635 62.8587 204.008 64.923 202.849 65.6312C202.654 65.7518 202.443 65.8321 202.222 65.8673L201.159 66.0431L200.973 66.0732V66.0581C199.418 66.1385 197.838 64.0893 197.386 61.3369C197.286 60.714 197.251 60.1113 197.276 59.5387C197.311 58.6096 197.507 57.7758 197.823 57.1178L197.507 56.1585L194.843 48.0771L193.694 44.5914L184.403 43.1599L189.109 57.0726H189.104Z",
    fill: "#F1F2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 87.8113H205.744L201.525 88.1328V126.275C202.965 126.149 204.39 125.978 205.799 125.752C206.301 125.672 206.798 125.587 207.294 125.496V87.6958L205.799 87.8063L205.804 87.8113Z",
    fill: "#E7EAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.023 87.4949L208.794 87.5853L207.299 87.6958V125.496C207.8 125.406 208.297 125.305 208.794 125.2C209.225 125.109 209.657 125.014 210.083 124.914V87.4849H210.023V87.4949Z",
    fill: "#D8D9E1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_2014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.996 44.5664H174.645H178.874H182.942L182.952 44.5965L183.394 44.5865L187.668 57.2285L190.457 65.4857L191.837 69.5691L193.327 69.5741L191.606 64.4812L189.103 57.0728L184.397 43.155L183.941 43.1701L183.936 43.155H158.973L157.563 47.5549L158.807 48.2831L159.996 44.5664Z",
    fill: "#C8CBDE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.932 73.6826V73.6876L151.875 72.4822L158.557 87.7661H160.092L153.942 73.6876L153.932 73.6826Z",
    fill: "#C8CBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.429 81.5732L189.434 81.5531L192.489 72.1557L193.327 69.5741L191.837 69.5691L191.842 69.5842L191.27 71.3521L187.899 81.7239L187.894 81.7389L185.932 87.7661H187.417L189.429 81.5732Z",
    fill: "#C8CBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.327 69.574L192.49 72.1556L189.434 81.553L189.429 81.5731L187.418 87.766L186.941 89.2276L201.524 88.1326L205.743 87.8112H205.804L207.299 87.6957L208.788 87.5852L210.023 87.4948L210.078 87.4897L213.007 87.2687L214.297 87.1733L236.666 85.4907L242.836 70.8447L203.305 69.8301L193.327 69.574Z",
    fill: "url(#paint2_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.387 55.2092L199.532 55.6512L200.516 55.4905C200.872 55.4302 201.228 55.4905 201.574 55.6462C201.609 55.6613 201.639 55.6814 201.674 55.6964C201.705 55.7115 201.74 55.7266 201.77 55.7467C202.196 55.9827 202.608 56.3644 202.969 56.8617C203.475 57.5598 203.897 58.474 204.148 59.5287C204.198 59.7447 204.248 59.9707 204.283 60.1967C204.303 60.3072 204.318 60.4127 204.328 60.5182L209.922 56.7261L202.708 47.9917L200.807 45.6863L193.216 36.4949L196.001 44.943L199.382 55.2042L199.387 55.2092Z",
    fill: "url(#paint3_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.502 56.1536L197.818 57.1129C198.038 56.6508 198.324 56.2791 198.66 56.023C198.851 55.8823 199.052 55.7718 199.273 55.7116V55.6965L199.463 55.6664L199.538 55.6563L199.393 55.2143L196.012 44.9531L193.228 36.505L191.281 30.6084L189.56 32.07L193.694 44.6015L194.843 48.0872L197.507 56.1686L197.502 56.1536Z",
    fill: "url(#paint4_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.45 61.1562C198.299 60.227 198.294 59.3329 198.409 58.5394C198.439 58.3435 198.475 58.1576 198.515 57.9768C198.725 57.0778 199.112 56.3545 199.623 55.9175C199.889 55.6915 200.19 55.5408 200.516 55.4856L199.533 55.6463L199.458 55.6564L199.262 55.6865V55.7016C199.046 55.7618 198.846 55.8723 198.655 56.013C198.319 56.2691 198.038 56.6408 197.812 57.1029C197.496 57.7609 197.306 58.5946 197.266 59.5238C197.246 60.0964 197.276 60.6991 197.376 61.3219C197.827 64.0743 199.403 66.1236 200.958 66.0432V66.0583L201.143 66.0281L202.207 65.8523C200.597 66.1185 198.906 64.009 198.439 61.1461L198.45 61.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.147 59.5287C203.896 58.479 203.475 57.5599 202.968 56.8617C202.607 56.3645 202.196 55.9828 201.769 55.7467C201.739 55.7266 201.704 55.7166 201.674 55.6965C201.639 55.6814 201.609 55.6613 201.574 55.6462C201.228 55.4905 200.871 55.4303 200.515 55.4905C200.189 55.5458 199.888 55.6965 199.622 55.9225C199.111 56.3595 198.729 57.0827 198.514 57.9818C198.469 58.1626 198.433 58.3534 198.408 58.5443C198.293 59.3379 198.298 60.2319 198.448 61.1611C198.92 64.024 200.606 66.1335 202.216 65.8673C202.442 65.8322 202.652 65.7468 202.843 65.6313C204.002 64.9231 204.629 62.8638 204.328 60.5232C204.313 60.4177 204.298 60.3073 204.283 60.2018C204.248 59.9758 204.197 59.7548 204.147 59.5338V59.5287ZM202.241 61.7688C201.87 61.8291 201.478 61.3419 201.368 60.6789C201.258 60.0159 201.473 59.4283 201.845 59.368C201.935 59.353 202.025 59.368 202.111 59.4132C202.131 59.4233 202.151 59.4383 202.176 59.4534C202.427 59.6141 202.642 59.9908 202.723 60.4579C202.808 60.9652 202.703 61.4223 202.482 61.6433C202.462 61.6634 202.442 61.6734 202.422 61.6885C202.366 61.7287 202.311 61.7638 202.246 61.7739L202.241 61.7688Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.406 61.5981C202.155 61.4323 201.94 61.0607 201.864 60.5986C201.784 60.0913 201.89 59.6342 202.105 59.4132C202.02 59.3731 201.93 59.353 201.839 59.368C201.468 59.4283 201.252 60.016 201.363 60.6789C201.473 61.3419 201.864 61.8291 202.236 61.7689C202.301 61.7588 202.361 61.7237 202.411 61.6835C202.431 61.6684 202.451 61.6584 202.471 61.6383C202.446 61.6282 202.426 61.6132 202.406 61.5981Z",
    fill: "#959697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.869 60.5934C201.945 61.0555 202.16 61.4322 202.411 61.5929C202.431 61.608 202.456 61.6231 202.476 61.6331C202.697 61.4172 202.802 60.9551 202.717 60.4478C202.642 59.9807 202.426 59.604 202.17 59.4433C202.15 59.4282 202.13 59.4131 202.105 59.4031C201.884 59.619 201.779 60.0811 201.864 60.5884L201.869 60.5934Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.941 89.2277L187.418 87.7661H185.933H174.741H160.092H158.557H140.021H129.752V89.2277H140.603H159.194H186.941Z",
    fill: "#C8CBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.932 73.6824L151.875 72.482L140.217 65.6562L151.875 72.482L153.932 73.6875V73.6824Z",
    fill: "#F8D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.807 48.283L166.312 52.6778L158.807 48.283Z",
    fill: "#003634"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.807 48.283L166.312 52.6778L158.807 48.283Z",
    fill: "#F8D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.592 30.5984L116.297 51.6533L136.779 48.3233L128.592 30.5984Z",
    fill: "url(#paint5_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.456 41.6382L142.59 38.7903L128.593 30.5984L142.59 38.7903L147.456 41.6382Z",
    fill: "#FAE6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.804 54.7321L139.744 54.7372L137.983 50.925L136.779 48.3232L116.297 51.6533L135.159 62.693L136.283 60.7693L139.804 54.7321Z",
    fill: "url(#paint6_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.984 50.925L139.745 54.7372L139.806 54.7322L144.22 47.1781L147.456 41.6382L142.59 38.7903L128.593 30.5984L136.781 48.3233L137.984 50.925Z",
    fill: "url(#paint7_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.113 63.2556L140.217 65.6564L136.113 63.2556Z",
    fill: "#622180"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.113 63.2556L140.217 65.6564L136.113 63.2556Z",
    fill: "#F8D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 47.5549L158.808 48.2831L166.227 52.6277L157.188 53.351L155.667 53.4715L146.788 54.1797L151.408 66.7865L152.196 68.9413L153.902 73.5922L153.932 73.6826L153.942 73.6877L154.022 73.7329L158.873 65.4254L160.95 61.8694L162.019 60.0311L166.313 52.678L158.808 48.2831L157.564 47.5549L147.455 41.6382L157.564 47.5549Z",
    fill: "#FAE6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.564 47.5549L158.808 48.2831L166.227 52.6277L157.188 53.351L155.667 53.4715L146.788 54.1797L151.408 66.7865L152.196 68.9413L153.902 73.5922L153.932 73.6826L153.942 73.6877L154.022 73.7329L158.873 65.4254L160.95 61.8694L162.019 60.0311L166.313 52.678L158.808 48.2831L157.564 47.5549L147.455 41.6382L157.564 47.5549Z",
    fill: "url(#paint8_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.217 65.6564L151.875 72.4822L153.932 73.6826L153.902 73.5922L152.196 68.9412L151.409 66.7865L146.788 54.1797L139.805 54.7322L136.284 60.7694L135.16 62.6931L136.113 63.2556L140.217 65.6564Z",
    fill: "#F8D977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.217 65.6564L151.875 72.4822L153.932 73.6826L153.902 73.5922L152.196 68.9412L151.409 66.7865L146.788 54.1797L139.805 54.7322L136.284 60.7694L135.16 62.6931L136.113 63.2556L140.217 65.6564Z",
    fill: "url(#paint9_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.188 53.351L166.228 52.6277L158.808 48.2831L157.564 47.5549L147.456 41.6382L144.22 47.1782L139.805 54.7322L146.789 54.1797L155.668 53.4715L157.188 53.351Z",
    fill: "#ECC955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.188 53.351L166.228 52.6277L158.808 48.2831L157.564 47.5549L147.456 41.6382L144.22 47.1782L139.805 54.7322L146.789 54.1797L155.668 53.4715L157.188 53.351Z",
    fill: "url(#paint10_linear_6_2014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.949 14.8774L216.91 37.9314L227.721 20.1914L208.949 14.8774Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.602 7.73022L224.275 9.57353L208.949 14.8774L224.275 9.57353L229.602 7.73022Z",
    fill: "#A6CBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.549 22.0699L234.514 22.1151L230.476 20.9699L227.722 20.1914L216.911 37.9314L237.559 30.7842L236.832 28.6746L234.549 22.0699Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.475 20.9699L234.514 22.1151L234.549 22.0699L231.694 13.7926L229.602 7.73022L224.275 9.57353L208.949 14.8774L227.721 20.1914L230.475 20.9699Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.602 30.4225L243.097 28.8655L238.602 30.4225Z",
    fill: "#86671C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M238.602 30.4225L243.097 28.8655L238.602 30.4225Z",
    fill: "#6CABF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.669 3.89795L242.034 3.42582L250.155 0.613144L244.818 7.95625L243.92 9.18679L238.672 16.3993L251.239 21.1005L253.386 21.8991L258.021 23.6319L258.117 23.6671L258.127 23.662L258.207 23.6369L255.067 14.5409L253.722 10.6434L253.03 8.6343L250.246 0.583008L242.034 3.42582L240.669 3.89795L229.602 7.73023L240.669 3.89795Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.097 28.8656L255.864 24.4457L258.117 23.6672L258.021 23.632L253.386 21.8992L251.239 21.1006L238.672 16.3994L234.548 22.07L236.831 28.6748L237.558 30.7843L238.602 30.4226L243.097 28.8656Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.818 7.95638L250.155 0.613281L242.034 3.42596L240.669 3.89809L229.602 7.73036L231.694 13.7927L234.549 22.07L238.672 16.3994L243.92 9.18693L244.818 7.95638Z",
    fill: "#989898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_2014",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_2014",
    transform: "scale(0.000684932 0.00158983)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_2014",
    x: 141.345,
    y: 30.1804,
    width: 68.2,
    height: 58.8557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.24365
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.10914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_2014"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_2014",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_2014",
    x1: 166.726,
    y1: 73.5491,
    x2: 166.726,
    y2: 44.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1792,
    stopColor: "#CCD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3835,
    stopColor: "#DEE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5326,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_2014",
    x1: 178.822,
    y1: 71.9207,
    x2: 178.822,
    y2: 44.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1792,
    stopColor: "#CCD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3835,
    stopColor: "#DEE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5326,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_2014",
    x1: 214.888,
    y1: 106.407,
    x2: 214.888,
    y2: 69.5739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1792,
    stopColor: "#CCD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3835,
    stopColor: "#DEE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5326,
    stopColor: "#E4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_2014",
    x1: 201.569,
    y1: 36.4949,
    x2: 201.569,
    y2: 60.5182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_2014",
    x1: 194.549,
    y1: 30.6084,
    x2: 194.549,
    y2: 57.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE9208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_2014",
    x1: 126.538,
    y1: 30.5984,
    x2: 126.538,
    y2: 51.6533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_2014",
    x1: 128.05,
    y1: 48.3232,
    x2: 128.05,
    y2: 62.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_2014",
    x1: 138.025,
    y1: 30.5984,
    x2: 138.025,
    y2: 54.7372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_2014",
    x1: 156.55,
    y1: 41.6382,
    x2: 156.55,
    y2: 73.7329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_2014",
    x1: 144.546,
    y1: 54.1797,
    x2: 144.546,
    y2: 73.6826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_2014",
    x1: 153.017,
    y1: 41.6382,
    x2: 153.017,
    y2: 54.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.91,
    height: 125.692,
    fill: "white",
    transform: "translate(116.297 0.583008)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_2014",
    width: 1460,
    height: 629,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpamdefence);
export default __webpack_public_path__ + "static/media/spamdefence.fd20aa700851f3205bb67a18d4d3c7c0.svg";
export { ForwardRef as ReactComponent };